'use client';
import SearchIcon from '@/components/ui/icons/search-icon';
import { useTranslations } from 'next-intl';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

const SearchBox = () => {
  const t = useTranslations('common');
  const searchParams = useSearchParams();
  const router = useRouter();
  const [searchValue, setSearchValue] = useState('');
  const pathname = usePathname();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchValue?.trim()?.length >= 3) {
      router.push(`/search?q=${encodeURIComponent(searchValue?.trim())}`);
    }
  };

  useEffect(() => {
    if (pathname?.endsWith('/search')) {
      const q = searchParams.get('q');
      setSearchValue(q);
    } else {
      setSearchValue('');
    }
  }, [searchParams, pathname]);

  return (
    <form
      onSubmit={handleSubmit}
      role='search'
      className='flex flex-1 items-center justify-between rounded-lg border border-[#F6F6F7] px-2 py-2.5 max-lg:w-full lg:px-4'
    >
      <input
        type='search'
        name='q'
        placeholder={t('Search for products, categories or brands')}
        value={searchValue}
        onChange={(e) => {
          if (pathname?.endsWith('/search') && !e.target.value) {
            router.push(`/`);
          }
          setSearchValue(e.target.value);
        }}
        className='flex-1 text-xs outline-none placeholder:text-sm max-md:placeholder:text-xs md:text-sm rtl:placeholder:lg:text-xs'
        enterKeyHint='search'
      />
      <button
        type='submit'
        className='focus:ring-primary-500 cursor-pointer rounded-sm focus:ring-2 focus:ring-offset-2 focus:outline-none'
      >
        <SearchIcon className='mx-0.5 max-md:size-3' />
      </button>
    </form>
  );
};

export default SearchBox;
